import { useState, useEffect } from "react";
import urls from "../../Utils/urls";
import axios from "axios";
import { Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LoadingButton } from "../../Utils/CustomComponent";

const ResetPassword = ({ closeModal }) => {
  const { handleSubmit, formState, setError, register, clearErrors, watch } =
    useForm({
      defaultValues: {},
    });

  const [emailValidated, setEmailValidated] = useState(false);
  const [keyValidated, setKeyValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");

  // Add a state variable to manage whether passwords match or not
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  useEffect(() => {
    if (password === confirmPassword) {
      clearErrors("confirmPassword");
      setPasswordsMatch(true);
    } else {
      setPasswordsMatch(false);
    }
  }, [password, confirmPassword]);

  const onSubmit = async (data) => {
    if (!emailValidated) {
      setLoading(true);
      try {
        const response = await axios.post(urls.forgotPassword.postEmail, {
          email: data.email,
        });

        if (response.data === "OK") {
          setEmailValidated(true);
        } else {
          setError("email", {
            type: "manual",
            message: "Email is not valid",
          });
        }
      } catch (error) {
        console.error("API error:", error);
      } finally {
        setLoading(false);
      }
    } else if (data.key && !keyValidated) {
      setLoading(true);
      try {
        const response = await axios.post(urls.forgotPassword.postTempKey, {
          email: data.email,
          temp_key: data.key,
        });
        if (response.status == "200") {
          setUserId(response.data.user_id);
          setKeyValidated(true);
        } else {
          setError("key", {
            type: "manual",
            message: "Key is not valid",
          });
        }
      } catch (error) {
        console.error("API error:", error);
        setError("key", {
          type: "manual",
          message: "Key is not valid",
        });
      } finally {
        setLoading(false);
      }
    } else if (keyValidated) {
      setLoading(true);
      if (!passwordsMatch) {
        setError("confirmPassword", {
          type: "manual",
          message: "Password and Confirm Password must match",
        });
      } else {
        clearErrors("confirmPassword");
        const id = toast.loading("Resetting Password");
        try {
          const response = await axios.post(urls.profile.postChangePassword, {
            user_id: userId,
            password: data.confirmPassword,
            type: "U",
            email_address: "",
          });
          if (response.data.status === "200") {
            toast.update(id, {
              render: "Password Changed Successfully",
              type: "success",
              isLoading: false,
              ...commonToast,
            });
          } else {
            setError("password", {
              type: "manual",
              message: "Password reset failed",
            });
            toast.update(id, {
              render: "Password reset failed",
              type: "error",
              isLoading: false,
              ...commonToast,
            });
          }
        } catch (error) {
          console.error("API error:", error);
        } finally {
          setLoading(false);
          closeModal();
        }
      }
    }
  };

  return (
    <div>
      <form>
        <div className="form-group col-sm-6">
          <label className="font-weight-bold">Email address</label>
          <input
            type="email"
            className="form-control"
            {...register("email", { required: true })}
            disabled={emailValidated}
          />
          {formState.errors.email && (
            <p style={{ color: "red" }}>{formState.errors.email.message}</p>
          )}
        </div>

        {emailValidated ? (
          <div>
            <div className="form-group col-sm-6 mt-3">
              <label className="font-weight-bold">Key</label>
              <input
                type="text"
                className="form-control"
                {...register("key", { required: true })}
                disabled={keyValidated}
              />
              {formState.errors.key && (
                <p style={{ color: "red" }}>{formState.errors.key.message}</p>
              )}
              {!keyValidated && <p>Please check your email to find the key.</p>}
            </div>
          </div>
        ) : null}

        {keyValidated ? (
          <div>
            <div className="form-group col-sm-6 mt-3">
              <label className="font-weight-bold">Password</label>
              <input
                type="password"
                className="form-control"
                {...register("password", { required: true })}
              />
            </div>
            <div className="form-group col-sm-6 mt-3">
              <label className="font-weight-bold">Confirm Password</label>
              <input
                type="password"
                className="form-control"
                {...register("confirmPassword", { required: true })}
              />
              {formState.errors.confirmPassword && (
                <p style={{ color: "red" }}>
                  {formState.errors.confirmPassword.message}
                </p>
              )}
            </div>
          </div>
        ) : null}

        {/* <Button
          className="text-white mt-5"
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isValid || loading || (!passwordsMatch && !formState.errors.confirmPassword)}
        >
          {keyValidated ? "Submit" : "Next"}
        </Button> */}
        <LoadingButton
          loading={loading}
          type="submit"
          onClick={handleSubmit(onSubmit)}
          className="text-white mt-5"
          title={keyValidated ? "Submit" : "Next"}
          disabled={
            !formState.isValid ||
            loading ||
            (!passwordsMatch && !formState.errors.confirmPassword)
          }
        />
      </form>
      <style>
        {`.span-color span {
          color: black;
         }
        `}
      </style>
    </div>
  );
};

export default ResetPassword;
